import { AppProps } from "@/AppProps.ts";
import { useCheckNewVersion } from "@/helpers/hooks/useCheckNewVersion.ts";
import { useRootAttributes } from "@/helpers/useRootAttributes.ts";
import { BookingEngine } from "@/pages/BookingEngine/BookingEngine.tsx";
import { client } from "@/stores/ApolloClient/ApolloClient.ts";
import { ApolloProvider } from "@apollo/client";
import i18n from "i18next";
import TagManager from "react-gtm-module";
import { Toaster } from "react-hot-toast";
import { I18nextProvider } from "react-i18next";
import "./i18n";

const bookingEngineDiv = document.getElementById("bookingEngine");
const gtmId = bookingEngineDiv?.getAttribute("data-gtm_id") || import.meta.env.VITE_GTM_ID;
if (gtmId) {
  const tagManagerArgs = { gtmId: gtmId };
  TagManager.initialize(tagManagerArgs);
}

export const App = (props: AppProps) => {
  useRootAttributes(props.rootDiv);
  useCheckNewVersion();

  return (
    <I18nextProvider i18n={i18n}>
      <ApolloProvider client={client}>
        <Toaster />
        <div className="bookingEngine">
          <BookingEngine />
        </div>
      </ApolloProvider>
    </I18nextProvider>
  );
};

export default App;
